import {
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  useDisclosure,
  AxesIcon,
} from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import * as layoutActions from '../../layout/actions/layout.actions';
import { getLayoutValueSelector } from '../../layout/selectors/layout.selectors';
import { BPM, MS } from '../../layout/types/layout-state.type';
import { CHANGE_LEAD_PLOT_UNIT } from '../../analytics/analytics.constants';
import { trackLeadPlotUnitChange } from '../../analytics/thunks/track-change-lead-plot-unit.thunk';
import { ToolButton } from '../../../features/tool/components/ToolButton';

const WIDTH = '8rem';
const AXIS_UNITS = [
  {
    label: 'RR (MS)',
    value: false,
  },
  {
    label: 'RR (BPM)',
    value: true,
  },
];

export const BeatIntervalsSelection: React.FC = () => {
  const dispatch = useDispatch();
  const showHrInBpm = useSelector(getLayoutValueSelector('showHrInBpm'));
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatchInterval = (showHrInBpm: boolean) => {
    dispatch(trackLeadPlotUnitChange(CHANGE_LEAD_PLOT_UNIT, showHrInBpm));
    dispatch(layoutActions.update({ update: { showHrInBpm } }));
    setInterval(() => (showHrInBpm === false ? MS : BPM));
  };

  return (
    <Menu>
      <ToolButton
        as={MenuButton}
        name='axis'
        label='Change Axis Unit'
        aria-label='Change Axis Unit'
        isTooltipOpen={isOpen}
        icon={<AxesIcon />}
        onClick={onClose}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
      />
      <MenuList minWidth='unset' width={WIDTH}>
        <MenuOptionGroup
          type='radio'
          onChange={(v) => dispatchInterval(v === 'true')}
          value={`${showHrInBpm}`}
        >
          {AXIS_UNITS.map((axisUnit) => (
            <MenuItemOption key={axisUnit.label} value={`${axisUnit.value}`}>
              {axisUnit.label}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};
